import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { gridPageRequest, loginResponse } from '../../model/common/common.model';
import { MenuItem } from 'primeng/api';
import _ from 'lodash';
import { SharedModule } from '../../shared/shared.module';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/app.store';
import { setMenuList } from '../../store/MenuList/menu.actions';
import { LoaderComponent } from '../loader/loader.component';
import { AdministratorService } from '../../services/administrator.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionStoreService } from '../../store/SessionStoreService';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { PurchaseorderService } from '../../services/purchaseorder.service';
import { SharedServiceService } from '../../services/shared-service.service';
import { ContactSupportLookupComponent } from '../Lookup/contact-support-lookup/contact-support-lookup.component';
import { DialogService } from 'primeng/dynamicdialog';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ViewChild } from '@angular/core';
import { InventoryService } from '../../services/inventory.service';

interface Notification {
  formattedParts: any;
  id: string;
  message: string;
  formattedMessage?: SafeHtml;
}

export interface NotificationDTO {
  id: number;
  recipientRole: string;
  message: string;
  isRead: boolean;
  isActive?: boolean;
  createdDate?: string;
}


@Component({
  selector: 'app-home',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})

export class HomeComponent implements OnInit {
  notificationDto: NotificationDTO[] = [];
  userRole: string = "";

  constructor(private sessionStoreService: SessionStoreService, private router: Router, private userService: UserService, private store: Store<AppState>, private administratorService: AdministratorService, private route: ActivatedRoute, private sanitizer: DomSanitizer, private porderservice: PurchaseorderService, private sharedService: SharedServiceService, public dialogService: DialogService, private inventoryService: InventoryService) { }

  loginResponse: loginResponse | undefined;
  menuTree: MenuItem[] = [];
  userAvatar: string = "";
  loader: boolean = false;
  isDarkMode: boolean = false;
  size: number = 12;
  companyInfo: any[] = [];
  companyLogo: any;
  fullMenuList: any[] = [];
  menuVisible: boolean = false;
  notifications: Notification[] = [];
  customerSupportEmail: any;
  currentYear: number | undefined;
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 20,
    id: 0
  }

  ngOnInit(): void {

    this.loader = true;
    this.currentYear = new Date().getFullYear();
    let authData = localStorage.getItem("auth");
    this.getALLMenus();

    if (authData) {
      try {
        this.loginResponse = JSON.parse(authData) as loginResponse;

        this.userAvatar = this.loginResponse.user.firstName.substring(0, 1).toUpperCase() +
          this.loginResponse.user.lastName.substring(0, 1).toUpperCase();

        this.userRole = this.loginResponse.roles[0].name;

        const token = this.loginResponse.token;
        const sessionExpirationTimeInSeconds = 300;
        this.sessionStoreService.setSessionExpiration(token, sessionExpirationTimeInSeconds);

        this.userService.getUserMenuTree(this.loginResponse.user.id).subscribe(data => {
          this.menuTree = this.populateMenutree(data);
          this.storeMenuList(data);
          this.loader = false;
        },
          (error: any) => {
            console.error(error);
            this.loader = false;
          });

      } catch (error) {
        console.error('Error parsing auth data:', error);
        this.loader = false;
        this.router.navigate(['/']);
      }
    } else {
      console.error('No auth data found in localStorage.');
      this.loader = false;
      this.router.navigate(['/']);
    }

    this.sharedService.menuRefresh$.subscribe(() => {
      this.refreshMenu();
    });

    this.getLocalStorageValue();
    this.getCompanyDetails();
    this.loadNotifications();
    this.loadNotificationService();
    this.getSystemConfigsData();
  }


  populateMenutree(menu: any): MenuItem[] {
    const menuTree: MenuItem[] = [];

    const sortedMenu = _.sortBy(menu, (menuItem: any) => {
      const match = this.fullMenuList.find(m => m.title === menuItem.description);
      return match ? match.displayOrder : 999;
    });

    _.forEach(sortedMenu, (item) => {
      const menuItem: MenuItem = {
        id: item.name,
        label: item.description,
        title: item.description,
        routerLink: `${item.name}`,
        command: (event) => this.onMenuItemSelect(item)
      };

      if (item.subMenu && item.subMenu.length > 0) {
        menuItem.items = this.getSubMenu(item);
        menuItem.routerLink = '';
      }

      menuTree.push(menuItem);
    });

    return menuTree;
  }

  getSubMenu(menuItem: any): MenuItem[] {
    const submenu: MenuItem[] = [];

    if (menuItem.subMenu && menuItem.subMenu.length > 0) {
      const sortedSubMenus = _.sortBy(menuItem.subMenu, ['displayOrder']);

      _.forEach(sortedSubMenus, item => {
        const subMenuItem: MenuItem = {
          id: item.name,
          label: item.description,
          title: item.description,
          icon: "pi pi-list",
          routerLink: `${item.name}`,
          command: (event) => this.onMenuItemSelect(item)
        };

        if (item.subMenu && item.subMenu.length > 0) {
          subMenuItem.items = this.getSubMenu(item);
        }

        submenu.push(subMenuItem);
      });
    }

    return submenu;
  }


  storeMenuList(menuList: any) {
    this.store.dispatch(setMenuList({ menuList }));
  }

  darkMode() {
    this.isDarkMode = !this.isDarkMode;
    localStorage.setItem('DarkMode', this.isDarkMode.toString());
    if (this.isDarkMode) {
      document.documentElement.style.backgroundColor = "black";
    } else {
      document.documentElement.style.backgroundColor = "white";
    }
  }

  increase() {
    if (this.size < 17) {
      this.size++;
      document.documentElement.style.fontSize = `${this.size}px`;
      localStorage.setItem('screensize', this.size.toString());
    }
  }

  decrease() {
    if (this.size >= 10) {
      this.size--;
      document.documentElement.style.fontSize = `${this.size}px`;
      localStorage.setItem('screensize', this.size.toString());
    }
  }

  getLocalStorageValue() {
    const darkModeValue = localStorage.getItem('DarkMode');
    this.isDarkMode = darkModeValue === 'true' ? true : false;
    if (this.isDarkMode) {
      document.documentElement.style.backgroundColor = "black";
    }

    const screensize = localStorage.getItem('screensize');
    this.size = _.toNumber(screensize);
    if (screensize == null) {
      this.size = 13;
    }
    document.documentElement.style.fontSize = `${this.size}px`;

  }

  getCompanyDetails() {
    this.administratorService.getCompanyDetails().subscribe(
      (data: any) => {
        if (data) {
          this.companyLogo = data[0].companyLogo ? `data:image/jpeg;base64,${data[0].companyLogo}` : './assets/no-image.jpg';
          this.companyInfo = data.map((company: any) => {
            return {
              ...company,
              companyLogo: company.companyLogo ? `data:image/jpeg;base64,${company.companyLogo}` : './assets/no-image.jpg'
            };
          });
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getALLMenus(): void {
    this.loader = true;
    this.userService.getALLMenus(this.pageRequest).subscribe({
      next: (data: any) => {
        if (data && data.menus) {
          this.fullMenuList = data.menus;
        }
      },
      error: error => {
        this.loader = false;
        console.log(error);
      }
    });
  }

  logout() {
    const userId = this.loginResponse?.user?.id;

    if (userId) {
      this.userService.logout(userId).subscribe({
        next: () => this.finishLogout(),
        error: () => this.finishLogout()
      });
    } else {
      this.finishLogout();
    }
  }

  private finishLogout(): void {
    localStorage.clear();
    this.router.navigate(['/']);
  }

  toggleMenu() {
    this.menuVisible = !this.menuVisible;
  }
  onMenuItemSelect(item: any) {
    // console.log('Selected Node:', item);

    if (item?.subMenu && item.subMenu.length > 0) {
      this.menuVisible = true;
      return;
    }
    if (item?.name) {
      this.menuVisible = false;
      this.router.navigate([item.name], { relativeTo: this.route });
    }
  }

  async loadNotifications() {
    const username = this.loginResponse?.user?.firstName;

    if (!username) {
      console.error('Username not available');
      return;
    }

    this.userService.getNotifications(username).subscribe({
      next: async (data) => {
        this.notifications = await Promise.all(
          data.map(async (note: { message: string; formattedMessage: any; }) => {
            let updatedMessage = note.message;

            const poMatch = updatedMessage.match(/LL\\[A-Za-z0-9\-]+/);
            if (poMatch) {
              const poCode = poMatch[0];
              try {
                const poDetails = await firstValueFrom(this.porderservice.getPurchaseOrderByPONumber(poCode));
                const purchaseOrderId = poDetails?.id || poDetails;
                if (purchaseOrderId) {
                  const poUrl = `home/createPurchaseOrder?purchaseOrderId=${encodeURIComponent(purchaseOrderId)}`;
                  const poAnchor = `<a href="${poUrl}" style="color: blue;">${poCode}</a>`;
                  updatedMessage = updatedMessage.replace(poCode, poAnchor);
                }
              } catch (err) {
                console.error('Error fetching PO details:', err);
              }
            } else {
              const taskMatch = updatedMessage.match(/Task\s*(\d+)/i);
              if (taskMatch) {
                const taskCode = taskMatch[1];
                try {
                  const taskDetails = await firstValueFrom(this.porderservice.getTaskByCode(taskCode));
                  const taskId = taskDetails || taskDetails;
                  if (taskId) {
                    const taskUrl = `home/createtask?key=${encodeURIComponent(taskId)}`;
                    const taskAnchor = `<a href="${taskUrl}" style="color: blue;">${taskCode}</a>`;
                    updatedMessage = updatedMessage.replace(taskCode, taskAnchor);
                  }
                } catch (err) {
                  console.error('Error fetching task details:', err);
                }
              }
            }

            note.formattedMessage = this.sanitizer.bypassSecurityTrustHtml(updatedMessage);
            return note;
          })
        );
      },
      error: (err) => console.error('Error loading notifications', err)
    });
  }

  async loadNotificationService() {
    const username = this.loginResponse?.user?.firstName;

    if (!username) {
      console.error('Username not available');
      return;
    }

    this.userService.getNotificationService(this.userRole).subscribe({
      next: async (data) => {
        // console.log('Notifications received:', data);
        this.notificationDto = data.map((n: any) => {
          return {
            ...n,
            message: this.sanitizer.bypassSecurityTrustHtml(n.message)
          };
        });


        this.loader = false;
      },
      error: (err) => console.error('Error loading notifications', err)
    });
  }

  //   open(n: any) {
  //   if (n.notificationType === 'VendorBillDue') {
  //     this.router.navigate(['/vendor-bill/view'], {
  //       queryParams: { id: n.referenceId }
  //     });
  //   }
  //   this.notificationService.markRead(n.id).subscribe();
  // }

  refreshMenu(): void {
    if (this.loginResponse?.user?.id) {
      this.userService.getUserMenuTree(this.loginResponse.user.id).subscribe(data => {
        this.menuTree = this.populateMenutree(data);
        this.storeMenuList(data);
      });
    }
  }


  onSupportClick() {
    this.dialogService.open(ContactSupportLookupComponent, {
      header: 'At your service!',
      width: '40%',
      data: {
        defaultEmail: this.customerSupportEmail
      }
    });
  }

  openHelp(section: string): void {
    switch (section) {
      case 'user-guide':
        this.router.navigate(['/help/user-guide']);
        break;
      case 'dev-guide':
        this.router.navigate(['/help/developer-guide']);
        break;
      case 'faqs':
        this.router.navigate(['/help/faqs']);
        break;
      case 'security':
        this.router.navigate(['/help/security-practices']);
        break;
      case 'contact':
        this.onSupportClick();
        break;
    }
  }


  dismissNotification(index: number): void {
    const notification = this.notificationDto[index];
    this.userService.markNotificationAsRead(notification.id).subscribe({
      next: () => {
        this.notificationDto.splice(index, 1);
      },
      error: err => {
        console.error('Failed to mark notification read', err);
        // Optionally still remove from UI or show error
      }
    });
  }

  isOpen = true;
  @ViewChild('notificationPanel2') notificationPanel2!: OverlayPanel;
  handleClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (target.tagName === 'A') {
      event.preventDefault();

      const href = target.getAttribute('href');
      if (!href) return;

      // Example: parse href like "/home/createproductrequisition?productRequisitionId=2380"
      const url = new URL(href, window.location.origin);

      const path = url.pathname;
      const queryParams: any = {};

      url.searchParams.forEach((value, key) => {
        queryParams[key] = value;
      });

      this.router.navigate([path], { queryParams });
      this.notificationPanel2.hide();
    }
  }

  getSystemConfigsData(): void {
    this.loader = true;
    const appKey = 'CustomerSupportEmail';

    this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
      next: (response: any) => {
        this.loader = false;
        this.customerSupportEmail = response?.data;
      },
      error: (error: any) => {
        console.error('Error fetching System Config Data:', error);
        this.loader = false;
      }
    });
  }

}
